import React from 'react';
import ReactDOM from 'react-dom';
// store
import { Provider } from 'react-redux';
import store from './store/configureStore';
// router
import { BrowserRouter as Router } from 'react-router-dom';
// components
import { App } from './App';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
// utils
import './utils/fontawesome';
import LuxonUtils from '@date-io/luxon';
import * as serviceWorker from './serviceWorker';
// styles
import './index.css';

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <MuiPickersUtilsProvider utils={LuxonUtils}>
        <App />
      </MuiPickersUtilsProvider>
    </Router>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
